  (function () {
    var allowedPaths = ['/collections/new-arrival', '/collections/all'];
    var currentPath = window.location.pathname;
    var el = document.getElementById('Details-1-template--22787264020705__product-grid');

    if (el && allowedPaths.indexOf(currentPath) === -1) {
      el.style.display = 'none';
    }
  })();